import { retentionScheduleSetting } from '@vello/privacy';
import { BRAZIL } from './brazil.js';
const LGPD_ERASURE = 'LGPD (Lei 13.709/2018) art. 16 e art. 18, VI — sem dever legal de guarda: eliminação a pedido do titular';
const CLAIMS = 'CDC (Lei 8.078/1990) art. 27 (5 anos) e LGPD art. 7º, VI, e art. 16, I — defesa em processo';
const FISCAL = 'CTN (Lei 5.172/1966) art. 173 e art. 195, parágrafo único — guarda dos registros fiscais por 5 anos';
/** The schedule the pack publishes (v1). */
export const BRAZIL_RETENTION_SCHEDULE = {
    entries: [
        { dataClass: 'Confidential', retentionDays: 0, basis: LGPD_ERASURE },
        { dataClass: 'Sensitive-Location', retentionDays: 0, basis: LGPD_ERASURE },
        { dataClass: 'Restricted-PII', retentionDays: 0, basis: LGPD_ERASURE },
        { dataClass: 'Restricted-PII', purpose: 'kyc_document', retentionDays: 1825, basis: CLAIMS },
        { dataClass: 'Restricted-PII', purpose: 'kyc_check', retentionDays: 1825, basis: CLAIMS },
        { dataClass: 'Restricted-PII', purpose: 'identity_recheck', retentionDays: 1825, basis: CLAIMS },
        { dataClass: 'Restricted-PII', purpose: 'driver_profile', retentionDays: 1825, basis: CLAIMS },
        { dataClass: 'Restricted-PII', purpose: 'vehicle_registration', retentionDays: 1825, basis: CLAIMS },
        { dataClass: 'Restricted-PII', purpose: 'biometric_consent', retentionDays: 1825, basis: 'LGPD art. 8º, §2º — ônus da prova do consentimento; art. 16, I' },
        { dataClass: 'Financial', retentionDays: 1825, basis: FISCAL },
        { dataClass: 'Safety-Critical', retentionDays: 'indefinite', basis: 'LGPD art. 7º, VI, e art. 16, I — evidência de segurança enquanto o caso puder ser reaberto' },
    ],
};
/**
 * v2 (H1-RULES, D503; owner Q-019, 2026-10-05): support tickets are kept five years, not forever. A PURPOSE entry wins over the class-wide
 * `Safety-Critical` one, so a safety incident or risk case keeps its indefinite window while a support ticket (and its thread) ends at five
 * years; an OPEN ticket and an open legal hold still hold (the case eraser flags the one, the hold provider the other).
 */
export const BRAZIL_RETENTION_SCHEDULE_V2 = {
    entries: [
        ...BRAZIL_RETENTION_SCHEDULE.entries,
        { dataClass: 'Safety-Critical', purpose: 'support_ticket', retentionDays: 1825, basis: CLAIMS },
    ],
};
/** When v2 takes effect (the owner's decision date, UTC). */
export const BRAZIL_RETENTION_SCHEDULE_V2_EFFECTIVE_FROM = '2026-10-05T00:00:00Z';
/** When the schedule takes effect (the D439 date, UTC). */
export const BRAZIL_RETENTION_SCHEDULE_EFFECTIVE_FROM = '2026-09-25T00:00:00Z';
/** Brazil's retention schedule versions: v1 (D439) and v2 (D503, support tickets kept five years). */
export function brazilRetentionScheduleSettings() {
    return [
        retentionScheduleSetting({ country: BRAZIL, value: BRAZIL_RETENTION_SCHEDULE, version: 1, effectiveFrom: BRAZIL_RETENTION_SCHEDULE_EFFECTIVE_FROM }),
        retentionScheduleSetting({ country: BRAZIL, value: BRAZIL_RETENTION_SCHEDULE_V2, version: 2, effectiveFrom: BRAZIL_RETENTION_SCHEDULE_V2_EFFECTIVE_FROM }),
    ];
}
/**
 * Publish Brazil's retention schedule through the caller's `publish` (the pack seed routes a kernel key through the
 * governed seed path — `@vello/pack-seed` `seedCountryPacks`). Idempotent: a re-run publishes nothing.
 */
export async function publishBrazilRetentionSchedulePolicies(publish, newId, now) {
    let count = 0;
    for (const setting of brazilRetentionScheduleSettings()) {
        if (await publish(setting, newId(), now))
            count += 1;
    }
    return count;
}
//# sourceMappingURL=retention-schedule.js.map